function GetStartedIcon() {
	return (
		<svg
			width="67"
			height="68"
			viewBox="0 0 67 68"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<mask
				id="path-1-outside-1_390_58033"
				maskUnits="userSpaceOnUse"
				x="-0.5"
				y="0"
				width="68"
				height="68"
				fill="black"
			>
				<rect fill="white" x="-0.5" width="68" height="68" />
				<path d="M65.5 34C65.5 51.6731 51.1731 66 33.5 66C15.8269 66 1.5 51.6731 1.5 34C1.5 16.3269 15.8269 2 33.5 2C51.1731 2 65.5 16.3269 65.5 34Z" />
			</mask>
			<g
				clipPath="url(#paint0_angular_390_58033_clip_path)"
				data-figma-skip-parse="true"
				mask="url(#path-1-outside-1_390_58033)"
			>
				<g transform="matrix(0 0.032 -0.032 0 33.5 34)">
					<foreignObject
						x="-1046.88"
						y="-1046.88"
						width="2093.75"
						height="2093.75"
					>
						<div
							style={{
								background:
									"conic-gradient(from 90deg,rgba(255, 255, 255, 0) 0deg,rgba(255, 255, 255, 0) 37.9858deg,rgba(255, 255, 255, 1) 180deg,rgba(255, 255, 255, 0) 320.024deg,rgba(255, 255, 255, 0) 360deg)",
								height: "100%",
								width: "100%",
								opacity: "1",
							}}
						></div>
					</foreignObject>
				</g>
			</g>
			<path
				d="M64 34C64 50.8447 50.3447 64.5 33.5 64.5V67.5C52.0015 67.5 67 52.5015 67 34H64ZM33.5 64.5C16.6553 64.5 3 50.8447 3 34H0C0 52.5015 14.9985 67.5 33.5 67.5V64.5ZM3 34C3 17.1553 16.6553 3.5 33.5 3.5V0.5C14.9985 0.5 0 15.4985 0 34H3ZM33.5 3.5C50.3447 3.5 64 17.1553 64 34H67C67 15.4985 52.0015 0.5 33.5 0.5V3.5Z"
				data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_ANGULAR&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:0.10551620274782181},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.50},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:0.88895541429519653}],&#34;stopsVar&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:0.10551620274782181},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.50},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:0.88895541429519653}],&#34;transform&#34;:{&#34;m00&#34;:3.9188699282725371e-15,&#34;m01&#34;:-64.0,&#34;m02&#34;:65.50,&#34;m10&#34;:64.0,&#34;m11&#34;:3.9188699282725371e-15,&#34;m12&#34;:2.0},&#34;opacity&#34;:1.0,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
				mask="url(#path-1-outside-1_390_58033)"
			/>
			<path
				d="M28.26 39.3601L33.38 44.4801L38.5 39.3601"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M33.3799 24L33.3799 44.34"
				stroke="white"
				strokeWidth="1.5"
				strokeMiterlimit="10"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<defs>
				<clipPath id="paint0_angular_390_58033_clip_path">
					<path
						d="M64 34C64 50.8447 50.3447 64.5 33.5 64.5V67.5C52.0015 67.5 67 52.5015 67 34H64ZM33.5 64.5C16.6553 64.5 3 50.8447 3 34H0C0 52.5015 14.9985 67.5 33.5 67.5V64.5ZM3 34C3 17.1553 16.6553 3.5 33.5 3.5V0.5C14.9985 0.5 0 15.4985 0 34H3ZM33.5 3.5C50.3447 3.5 64 17.1553 64 34H67C67 15.4985 52.0015 0.5 33.5 0.5V3.5Z"
						mask="url(#path-1-outside-1_390_58033)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default GetStartedIcon;
